// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { useContext } from 'react'
import { pathCartStoreContext } from 'components/PathCart/contexts'

/**
 * Returns the value of the pathCartStoreContext
 * @returns {array} - array of path summary objects
 */

const usePathCartStoreContext = () => (
  useContext(pathCartStoreContext)
)

export default usePathCartStoreContext
